/* ------------------------------------------------------------------------ */
/*		File: cmpIntro.tsx                                                  */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */


import React from "react";
import { ICmpIntro } from "./cmpIntro.d";
import "./cmpIntro.css";

/* ------------------------------------------------------------------------ */


const IntroComponent: React.FC<ICmpIntro> = (props) => {
    return (
        <div className="card_intro">
            <div className="card_intro_title">{props.label}</div>
            <div className="card_intro_description">{props.description}</div>
        </div>
    );
};

export default IntroComponent;